/**
 * @file Authenticated Axios client for dashboard APIs (Contributor, Admin, Expert, User).
 * Attaches JWT from localStorage on each request.
 */

import axios from "axios";
import { getApiBaseUrl } from "../config/apiConfig";

/** Default JSON client; base URL from `config/apiConfig` (supports dev proxy). */
const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Content-Type": "application/json" },
});

/** Inject `Authorization: Bearer <token>` when user is logged in. */
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Default export — axios Client. */
export default axiosClient;
